import { render, staticRenderFns } from "./BioTestingQuizDashboard.vue?vue&type=template&id=00a7e209"
import script from "./BioTestingQuizDashboard.vue?vue&type=script&lang=js"
export * from "./BioTestingQuizDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports